import React from 'react';
import { ISubModuleProps } from '../../types';
import { getClassNameFactory, Typography, Sizes } from '@dcl/ui';
import { TypographyTags } from '@dcl/ui/dist/elements/Typography';
import RightArrow from './icons/RightArrow';
import './SubModuleRedesigned.css';

export const SubModuleRedesigned: React.FC<ISubModuleProps> = (props) => {
  const { text, url, newTab } = props;
  const getClassName = getClassNameFactory(SubModuleRedesigned.displayName);
  const [isActive, setIsActive] = React.useState(false);

  const divParams = {
    role: 'button',
    tabIndex: 0,
    'aria-label': `Navigate to ${text}`,
    onKeyDown: (e: React.KeyboardEvent) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setIsActive(true);
        if (newTab) {
          window.open(url, '_blank');
        } else {
          window.location.href = url;
        }
      }
    },
    onClick: () => {
      setIsActive(true);
      if (newTab) {
        window.open(url, '_blank');
      } else {
        window.location.href = url;
      }
    },
  };

  return (
    <div
      className={getClassName({
        descendantName: 'subModuleRedesigned',
        modifiers: isActive && 'active',
      })}
    >
      <div
        className={getClassName({ descendantName: 'cardListItem' })}
        {...divParams}
      >
        <Typography
          tag={TypographyTags.SPAN}
          className={getClassName({ descendantName: 'cardListItemText' })}
          type={Sizes.SMALL}
        >
          {text}
          <RightArrow />
        </Typography>
      </div>
    </div>
  );
};

SubModuleRedesigned.displayName = 'SubModuleRedesigned';
